module.exports = __webpack_public_path__ + "static/img/news-20240522.7176429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-20240522.png
// module id = 9X43
// module chunks = 0